import React, { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { buildApiUrl } from "../../utils/apiHelper";

// Safety net for click/open-tracking links baked into emails sent while
// tracking links pointed at this frontend's own domain instead of the API
// (fastify.listeningOrigin was unset — see mailinflow-apis history). Those
// already-sent emails can't be fixed retroactively, so this route catches
// them here and forwards to the real API's /track endpoint.
export default function TrackRedirect() {
  const [params] = useSearchParams();
  const source = params.get("source");
  const redirect = params.get("redirect");

  useEffect(() => {
    if (!source) return;
    const query = redirect ? { source, redirect } : { source };
    window.location.replace(buildApiUrl("/track", query));
  }, [source, redirect]);

  if (!source) {
    return <Navigate to="/" replace />;
  }

  return null;
}
